import { createReducer, on, Action } from '@ngrx/store';

import * as FeatureActions from './fullscreen.actions';
import { FullscreenState } from './fullscreen.models';

export const FULLSCREEN_FEATURE_KEY = 'fullscreen';

export interface FullscreenPartialState {
  readonly [FULLSCREEN_FEATURE_KEY]: FullscreenState;
}

export const initialFullscreenState: FullscreenState = {
  fullscreenState: false,
};

const reducer = createReducer(
  initialFullscreenState,
  on(FeatureActions.setFullscreenState, (state, { fullscreenState }) => ({
    ...state,
    fullscreenState,
  }))
);

export function fullscreenReducer(state: FullscreenState | undefined, action: Action): FullscreenState {
  return reducer(state, action);
}
